/**
 * 登录用户操作封装
 */
const userKey = 'vue_user';
export default {
    //判断是否登录
    isLogin() {
        var info = $.cookie(userKey);
        if (info == undefined)
            return false;
        return true;
    },
    //是否是超级管理员
    isAdmin(){
        return this.getInfo().post==1;
    },
    //保存登录信息,后台操作
    save(info) {
        $.cookie.json = true;

        if (info.checked) {
            console.info(info);
            $.cookie(userKey, info, { path: '/', expires: 30 });
        } else {
            $.cookie(userKey, info, { path: '/' });
        }
    },
    //获取登录信息
    getInfo() {
        $.cookie.json = true;
        var info = $.cookie(userKey);
        //info = JSON.parse(info);
        return info;
    },
    //清空登录信息
    clear: function () {
        $.removeCookie(userKey, { path: '/' }); // => true
    }
}